import styled, { css } from 'styled-components';
import { Box, Button, inputMediumStyles } from '@bechtel/gds';
import { Scalars } from '@bechtel/types';

export const WorkPackageListContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const ListStyled = styled.div`
  overflow-y: auto;
  flex-grow: 1;
  height: 100vh;
`;

export const SearchContainerStyled = styled(Box)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const PaginationContainerStyled = styled(Box).attrs({
  py: { sm: '400' },
  justifyContent: { sm: 'center' },
})`
  border-top: 2px solid ${({ theme }) => theme.colors.grey[200]};
  z-index: 1;
`;

interface SearchCanvasButtonStyledProps {
  isDefaultFilterChange: Scalars['Boolean'];
}
export const SearchCanvasButtonStyled = styled(Button)<SearchCanvasButtonStyledProps>`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
  ${(props) =>
    props.isDefaultFilterChange &&
    css`
      background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      }
    `}
`;
